exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input[type=\"checkbox\"]{\n    cursor: pointer;\n    width: 20px; /*Desired width*/\n    height: 20px; /*Desired height*/\n    border: 1px black solid;\n  }", ""]);

